import MaterialTable from "@material-table/core";
import MatTableHeader from "../../MaterialTableHeader/MatTableHeader";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Button, Icon } from "@mui/material";
import { activeQuotesTableData } from "../../api";
import React, { useEffect, useState } from "react";
import _ from "lodash";
import { toast } from "react-toastify";

import { log } from "../../../Helper";
import ForwarderQuoteDialog from "../../Dialog/quoteDialog";
import LoaderComponent from "../../../LoaderComponent/LoaderComponent";
import { useUserInfo } from "../../../common/user-context";
import useFilterState from "../../../hooks/useFilterState";

const OrdersMaterialTable = ({ tableName }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(200);
  const [pageNumber, setPageNumber] = useState(0);
  const [selectedMachinesForQuote, setselectedMachinesForQuote] = useState([]);

  const { userData } = useUserInfo();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCloseLoader = () => {
    setOpenLoader(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [tableData, setTableData] = useState(Array(0));
  const [openLoader, setOpenLoader] = useState(false);

  const [open, setOpen] = React.useState(false);

  const handleQuoteDialogOpen = (data) => {
    if (userData.internal) {
      toast.warn("Internal user can not add quote");
      return;
    }
    log("Selected machines for quote ", data);
    setselectedMachinesForQuote(data);
    setOpen(true);
  };

  const getTableData = async () => {
    setIsLoading(true);
    try {
      const response = await activeQuotesTableData(
        pageNumber,
        pageSize,
        userData
      );
      if (!response || !Array.isArray(response)) {
        setTableData([]);
      } else {
        setTableData(response);
      }
    } catch (error) {
      log("Error occured when fetching active quotes: ", error);
      setTableData(Array(0));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (userData.length > 0 || userData.userId) {
      getTableData();
    }
  }, [userData]);

  const columns = [
    {
      title: "QuoteId",
      field: "quoteId",
      hidden: true,
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "OrderPathId",
      field: "orderPathId",
      hidden: true,
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Status",
      field: "isActive",
      sorting: false,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Comar",
      field: "comar",
      sorting: false,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Order Unit",
      field: "orderUnit",
      hidden: true,
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Order Number",
      field: "orderNumber",
      hidden: true,
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "ORDER YEAR",
      field: "orderYear",
      hidden: true,
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Pick-Up",
      field: "pickupLocation",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Destination",
      field: "destination",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Product",
      field: "product",
      sorting: false,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Dimensions",
      field: "dimension",
      sorting: false,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Weight",
      field: "weight",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Expected Timeframe",
      field: "expectedTimeframe",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Result",
      field: "result",
      hidden: true,
      sorting: true,
      render: (rowData) => (
        <Button style={{ font: "icon", fontSize: "10px" }}>Pending</Button>
      ),
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Action",
      field: "action",
      hidden: true,
      sorting: true,
      render: (rowData) => <Icon>save</Icon>,
      headerStyle: {
        fontSize: "12px",
      },
    },
  ];

  const [columnsWithFilter, handleFilterChange] = useFilterState(
    tableName,
    columns
  );

  return (
    <>
      {isLoading && <LoaderComponent />}

      {!isLoading && (
        <div className="flex flex-col mt-[-1.5rem]">
          <MatTableHeader getTableData={getTableData} />
          <MaterialTable
            columns={columnsWithFilter.map((col, index) => {
              if (
                col.tableData?.filterValue == "" ||
                col.tableData?.filterValue == null ||
                col.tableData?.filterValue == undefined
              ) {
                let colWithoutDefaultFilter = _.omit(
                  col,
                  "defaultFilter",
                  "tableData.filterValue"
                );
                return colWithoutDefaultFilter;
              } else {
                return {
                  ...col,
                  defaultFilter: col.tableData?.filterValue,
                };
              }
            })}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h6 className="left-[45%] absolute top-[40%] text-center">
                    No records to display
                  </h6>
                ),
              },
              pagination: {
                labelRowsPerPage: "Orders Per Page",
                labelRowsSelect: "Orders",
              },
            }}
            options={{
              rowStyle: {
                fontSize: 10,
              },
              selection: false,
              search: false,
              showTitle: false,
              grouping: false,
              pageSize: 100,
              filtering: true,
              draggable: false,
              maxBodyHeight: 600,
              headerStyle: {
                backgroundColor: "#367c2b",
                fontWeight: "400",
                color: "white",
                position: "sticky",
                top: 0,
                zIndex: 10,
              },
              tableContainerStyle: {
                maxHeight: 600,
                overflow: "auto",
              },
              pageSizeOptions: [100, 500, 1000],
              actionsColumnIndex: -1,
              filterCellStyle: {
                flex: 1,
              },
            }}
            title={"Quote Orders"}
            data={tableData}
            onFilterChange={(filters) => {
              // Create a map of current filters for quick lookup
              const filterMap = new Map();
              filters.forEach((filter) => {
                filterMap.set(filter.column.tableData.id, filter.value);
              });

              // Iterate over all columns to ensure each one is checked if the value is present in the filter map
              columnsWithFilter.forEach((col, columnId) => {
                const newValue = filterMap.get(columnId) || ""; // Default to empty string if not found

                // Update the filter state for each column
                handleFilterChange(columnId, newValue);
              });
            }}
            actions={[
              (rowData) => ({
                icon: () => (
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<AddCircleOutlineIcon />}
                  >
                    Quote
                  </Button>
                ),
                tooltip: "Add Quote",
                onClick: (event, rowData) => {
                  handleQuoteDialogOpen(rowData);
                },
              }),
            ]}
          />
          <ForwarderQuoteDialog
            open={open}
            handleClose={handleClose}
            selectedMachinesForQuote={selectedMachinesForQuote}
            handleCloseLoader={handleCloseLoader}
            getTableData={getTableData}
            userData={userData}
          />
        </div>
      )}
    </>
  );
};

export default OrdersMaterialTable;
